import {useEffect, useState} from 'react';
import axios from 'axios';
import {getGetHeaders} from './headers';
import {getDefaultDateRanges} from './dataFunctions';
import {ORDER_QUERY_DEFAULTS} from '../global/orderReceiptDefaults';

export const NEEDS_REVIEW_STATUS_ID = 8;

const POLL_INTERVAL_MS = 60000;

/**
 * Poll the number of orders currently in the Needs Review status.
 *
 * Drives the red "Needs Review (N)" status label and the in-app notification
 * so staff see flagged Shopify orders without watching the queue.
 *
 * @return {number} the current Needs Review order count
 */
export const useNeedsReviewCount = () => {
    const [count, setCount] = useState(0);

    useEffect(
        () => {
            let cancelled = false;

            const fetchCount = () => {
                axios({
                    method: 'GET',
                    url: localStorage.getItem('server') + '/api/v1/mgmt/orders/statusCount/' + NEEDS_REVIEW_STATUS_ID,
                    headers: getGetHeaders()
                }).then((response) => {
                    if (!cancelled && response.data) {
                        setCount(response.data.count ? response.data.count : 0);
                    }
                }).catch(() => {
                    // Leave the last known count; the next poll may recover
                });
            };

            fetchCount();
            const timer = setInterval(fetchCount, POLL_INTERVAL_MS);

            return () => {
                cancelled = true;
                clearInterval(timer);
            };

        }, []
    );

    return count;
};

/**
 * Build the Orders list URL query string filtered to Needs Review, using the
 * full date range so no flagged order is missed.
 *
 * @return {string}
 */
export const needsReviewOrdersQueryString = () => {
    const ranges = getDefaultDateRanges();
    const filter = {
        filter_list_view: ORDER_QUERY_DEFAULTS.filter_list_view,
        filter_by: 'status',
        filter_status_id: NEEDS_REVIEW_STATUS_ID,
        filter_from: ranges.from,
        filter_to: ranges.to
    };
    return '?filter=' + encodeURIComponent(JSON.stringify(filter))
        + '&page=1&per_page=' + ORDER_QUERY_DEFAULTS.per_page
        + '&sort=' + ORDER_QUERY_DEFAULTS.sort_by
        + '&order=' + ORDER_QUERY_DEFAULTS.sort_order;
};
